import { useEffect, useState } from "react";
import { ORGAN_MAP } from "@/lib/dadDesign";

export default function OrganConnections({ scene, active }) {
  const [paths, setPaths] = useState([]);
  useEffect(() => {
    const element = scene.current;
    if (!element) return;
    const measure = () => {
      const base = element.getBoundingClientRect();
      setPaths(ORGAN_MAP.flatMap(organ => {
        const card = element.querySelector('[data-testid="organ-card-' + organ.id + '"]');
        const hotspot = element.querySelector('[data-testid="organ-hotspot-' + organ.id + '"]');
        if (!card || !hotspot) return [];
        const a = card.getBoundingClientRect(), b = hotspot.getBoundingClientRect();
        if (!a.width || !a.height || !b.width || !b.height) return [];
        const x1 = (a.left < b.left ? a.right : a.left) - base.left, y1 = a.top + a.height / 2 - base.top;
        const x2 = b.left + b.width / 2 - base.left, y2 = b.top + b.height / 2 - base.top, mid = (x1 + x2) / 2;
        return [{ id: organ.id, d: "M" + x1 + "," + y1 + " C" + mid + "," + y1 + " " + mid + "," + y2 + " " + x2 + "," + y2 }];
      }));
    };
    measure();
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(measure) : null;
    observer?.observe(element);
    element.addEventListener("load", measure, true);
    window.addEventListener("resize", measure);
    return () => { observer?.disconnect(); element.removeEventListener("load", measure, true); window.removeEventListener("resize", measure); };
  }, [scene]);
  return <svg className="dad-connectors" aria-hidden="true">{paths.map(p => <path key={p.id} d={p.d} data-active={active === p.id} />)}</svg>;
}
